
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogAuthorFR]",
      function () {
        return require("private-next-pages/[...blogAuthorFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogAuthorFR]"])
      });
    }
  